module.exports = {"name":"Menu","widget":{"type":"menu","initData":{"menu":[]}}}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/menu/menu.json
// module id = 370
// module chunks = 0